<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="w-100 bg-blue">
        <u-animate-container>
        <u-animate
          name="fadeInUp"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="-50"
          animateClass="animated"
          :begin="false"
        >
            <div class="addressAndInfo">
              <div class="logo">
                  <RTEdgarLogo class="rte-logo" />
              </div>
              <div class="address-wrapper mx-auto col-white serif">
                  <h2 class="mt-4 mb-4">
                    {{ address }}, {{ suburb }}
                  </h2>
              </div>

              <div class="icons flex-row  mx-auto justify-content-between mb-5">
                <div class="icon-bed w-33-33 float-left">
                  <div class="icon w-50 float-left">
                    <bedIcon class="icon-bed icon-svg"/>
                  </div>
                  <div class="info w-50 col-white float-left">
                    {{ bed }}
                  </div>
                </div>

                <div class="icon-bath w-33-33 float-left">
                  <div class="icon w-50 float-left">
                    <bathIcon class="icon-bath icon-svg" />
                  </div>
                  <div class="info w-50 col-white float-left">
                    {{ bath }}
                  </div>
                </div>

                <div class="icon-car w-33-33 float-left">
                  <div class="icon w-50 float-left">
                    <carIcon class="icon-car icon-svg" />
                  </div>
                  <div class="info w-50 col-white float-left">
                    {{ parking }}
                  </div>
                </div>
              </div>
            </div>
          </u-animate>
        </u-animate-container>
      </div>
    </div>
  </div>
</template>

<script>

import RTEdgarLogo from '@/assets/core/rte-logo.svg';
import bedIcon from '@/assets/core/bed.svg';
import bathIcon from '@/assets/core/bath.svg';
import carIcon from '@/assets/core/car.svg';

export default {

  name: 'AddressAndInfo',
  components: {
    RTEdgarLogo,
    bedIcon,
    bathIcon,
    carIcon
  },
  data() {
    return {
      addresss: '',
      bed: '',
      bath: '',
      parking: '',
      suburb: ''
    }
  },
  created() {
    this.address = this.$store.getters.getAddress
    this.bed = this.$store.getters.getBed
    this.bath = this.$store.getters.getBath
    this.parking = this.$store.getters.getParking
    this.suburb = this.$store.getters.getSuburb
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .addressAndInfo {
    padding: 40px;
  }

  .rte-logo {
    width: 200px;
    margin-bottom: 30px;
    svg {
      width: 100%;
    }
  }
  .icons {
    width: 300px;
  }
  .icon {
    margin: 0 auto;
  }
  .icon-svg {
    width: 20px;
  }
  .info {
    text-align: left;
  }
  .address-wrapper {
    width: 100%;
    border-top: 1px solid $white;
  }

  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {

  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {

  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    .address-wrapper {
      width: 360px;
    }

  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {

  }
</style>
